import { DASHBOARD_LITE_PARTNER_BROKER_ACTION_TYPES } from '@constants/actionTypes/dashboardLiteActionTypes';

export const INITIAL_STATE = {
    isLoading: false,
    error: null,
    partner: null,
    broker: null
};

export default (state = INITIAL_STATE, action = {}) => {
    const { type, payload } = action;
    switch (type) {
        case DASHBOARD_LITE_PARTNER_BROKER_ACTION_TYPES.FETCH_PARTNER_BROKER_START:
            return {
                ...state,
                isLoading: true

            };
        case DASHBOARD_LITE_PARTNER_BROKER_ACTION_TYPES.FETCH_PARTNER_BROKER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                partner: payload.partner,
                broker: payload.broker,
            };

        case DASHBOARD_LITE_PARTNER_BROKER_ACTION_TYPES.FETCH_PARTNER_BROKER_FAIL:
            return  {
                ...state,
                isLoading: false,
                error: payload
            };
        default:
            return state;
    }
};